(function () {
  'use strict';
  if (window.__BLOCKDEDUP_PRODUCT_RECOMMENDATIONS__) return;
  window.__BLOCKDEDUP_PRODUCT_RECOMMENDATIONS__ = true;

  // Dedup-guarded asset loaders; resolve immediately if already present. A createElement'd
  // <script> executes (unlike an innerHTML-injected one). Fail open on error (CSS scroll-snap
  // still gives a usable horizontal list).
  function loadOnce(kind, href) {
    return new Promise(function (resolve) {
      var flag = '__rpAsset_' + kind;
      if (window[flag]) { resolve(); return; }
      var sel = kind === 'css' ? 'link[data-rp-css]' : 'script[data-rp-js]';
      if (document.querySelector(sel)) { window[flag] = true; resolve(); return; }
      var el;
      if (kind === 'css') {
        el = document.createElement('link'); el.rel = 'stylesheet'; el.href = href; el.setAttribute('data-rp-css', '');
      } else {
        el = document.createElement('script'); el.src = href; el.defer = true; el.setAttribute('data-rp-js', '');
      }
      el.onload = function () { window[flag] = true; resolve(); };
      el.onerror = function () { resolve(); };
      document.head.appendChild(el);
    });
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      // Re-fires on editor shopify:section:load re-renders (element is re-parsed) — so no
      // separate document-level listener is needed (that would double-fetch).
      if (window.Shopify && Shopify.designMode) { this.load(); return; }
      this.observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        this.observer.unobserve(this);
        this.load();
      }.bind(this), { rootMargin: '0px 0px 400px 0px' });
      this.observer.observe(this);
    }

    load() {
      var url = this.dataset.url;
      if (!url) return;
      var self = this;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var tmp = document.createElement('div');
          tmp.innerHTML = text;
          var sid = self.dataset.sectionId;
          var fresh = tmp.querySelector('product-recommendations[data-section-id="' + sid + '"]')
                    || tmp.querySelector('product-recommendations');
          // Swap only when products are present; otherwise leave the empty shell (storefront:
          // invisible) or the editor placeholder in place.
          if (!fresh || !fresh.querySelector('.recommendation-products')) return;
          if (fresh.querySelector('[data-rp-carousel-id]')) {
            Promise.all([
              loadOnce('css', self.dataset.assetCarouselCss),
              loadOnce('js',  self.dataset.assetCarouselJs)
            ]).then(function () {
              self.innerHTML = fresh.innerHTML;
              if (typeof window.__rpCarouselInit__ === 'function') window.__rpCarouselInit__(self);
            });
          } else {
            self.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function (e) { console.error('Product recommendations:', e); });
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();
